import { DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Table,
  Tooltip,
  Typography,
} from "antd";
import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addSalaryComponents, deleteSalaryComponents, loadAllSalaryComponents } from "../../redux/rtk/features/salaryComponent/salaryComponentSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import EditSalaryComponent from "./EditSalaryComponent";

function CustomTable({ list, loading }) {
  const [columnsToShow, setColumnsToShow] = useState([]);
  const dispatch = useDispatch();

  const handleDelete = async (id) => {
    await dispatch(deleteSalaryComponents(id));
    dispatch(loadAllSalaryComponents()); // Refresh the list after deletion
  };

  const columns = [
    {
      id: 1,
      title: "S.No",
      dataIndex: "id",
      key: "id",
    },
    {
      id: 3,
      title: "Component Name",
      dataIndex: "componentName",
      key: "componentName",
    },
    {
      id: 2,
      title: "Component Type",
      dataIndex: "componentType",
      key: "componentType",
    },

    {
      id: 4,
      title: "Calculation Type",
      dataIndex: "calculationType",
      key: "calculationType",
    },
   
    {
      id: 6,
      title: "Pro-rata basis",
      dataIndex: "proRata",
      key: "proRata",
      render: (text, record) => <Checkbox checked={text} disabled />,
    },
    {
      id: 7,
      title: "Taxable Component",
      dataIndex: "taxable",
      key: "taxable",
      render: (text, record) => <Checkbox checked={text} disabled />,
    },
    {
      id: 8,
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <>
          <EditSalaryComponent record={record} />
          <Button
            type="danger"
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.id)}
          />
        </>
      ),
    },
  ];

  useEffect(() => {
    setColumnsToShow(columns);
  }, []);

  const columnsToShowHandler = (val) => {
    setColumnsToShow(val);
  };

  // const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

  const addKeys = (arr) => {
    if (!Array.isArray(arr)) {
      return [];
    }
    return arr.map((i) => ({ ...i, key: i.id }));
  };

  return (
    <Card>
      <div className="text-center my-2 flex justify-between">
        <h5 className="department-list-title text-color-2 text-xl mb-2">
          Components List
        </h5>
      </div>

      <Table
        scroll={{ x: true }}
        loading={loading}
        columns={columnsToShow}
        dataSource={list ? addKeys(list) : []}
      />
    </Card>
  );
}

const SalaryComponents = ({ drawer }) => {
  const { Title } = Typography;
  const { Option } = Select;
  const [loader, setLoader] = useState(false);
  const { list, loading } = useSelector((state) => state.salaryComponents);
  const [form] = Form.useForm();
  const [salaryComponents, setSalaryComponents] = useState([]);
  const [initValues, setInitValues] = useState(null);
  const [componentType, setComponentType] = useState("earning");
  const [calculationType, setCalculationType] = useState("Amount");
  const [prorata, setProrata] = useState(false);
  const [taxable, setTaxable] = useState(false);
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);


useEffect(() => {
  dispatch(loadAllSalaryComponents());
}, []);


  const onFinish = async (values) => {
    const salaryComponentData = {
      ...values,
      componentType:values.componentType,
      componentName: values.componentName,
      calculationType: calculationType,
      proRata: prorata,
      taxable: taxable
    };
    console.log("salaryComponentData>", salaryComponentData)
    const resp = await dispatch(addSalaryComponents(salaryComponentData));
    
    if (resp.payload.message === 'success') {
      setLoader(false);
      setSalaryComponents([]);
      // toast.success('Component saved successfully');
				dispatch(loadAllSalaryComponents());
      setEditMode(false);
    } else {
      setLoader(false);
      toast.error('Failed to save component');
    }
  
    
    if (editMode) {
      const updatedEntries = salaryComponents.map((entry) => {
        // if (entry.key === editingKey) {
        //   return salaryComponentData;
        // }
        return entry;
      });
      setSalaryComponents(updatedEntries);
      setEditMode(false);
    } else {
      setSalaryComponents([salaryComponentData]);
    }
  
    form.resetFields();
    // setThumbFileList([]);
  };

  const onFinishFailed = (errorInfo) => {
    toast.warning("Failed at adding status");
    setLoader(false);
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"create-setting"}>
        <Row className="mr-top" justify={drawer ? "center" : "space-between"}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={drawer ? 22 : 16}
            xl={drawer ? 22 : 12}
            className="column-design border rounded card-custom"
          >
            {/* <Card bordered={false}> */}
            <Title level={4} className="m-2 mt-5 mb-5 text-center">
              Salary Component
            </Title>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              eventKey="component-form"
              name="salaryComponentForm"
              labelCol={{
                span: 8,
              }}
              wrapperCol={{
                span: 12,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <div>
                <Form.Item
                  style={{ marginBottom: "5px" }}
                  label="Component Type"
                  name="componentType"
                  rules={[
                    {
                      required: true,
                      message: "Please select the component type!",
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="Income">Income</Radio>
                    <Radio value="Deduction">Deduction</Radio>
                  </Radio.Group>
                </Form.Item>

                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Component Name"
                  name="componentName"
                  rules={[
                    {
                      required: true,
                      message: "Please input the component name!",
                    },
                  ]}
                >
                  <Input placeholder="HRA" />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  label="Calculation Type"
                  name="calculationType"
                  rules={[
                    {
                      required: true,
                      message: "Please select the Calculation type!",
                    },
                  ]}
                >
                  <Select onChange={(value) => setCalculationType(value)}>
                    <Option value="Amount">Amount</Option>
                    <Option value="% of Basic">Percentage of Basic</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "5px" }}
                  label={
                    <span>
                      Pro-rata basis
                      <Tooltip title="Pro-rata basis means the calculation is based on a proportionate basis. For example, if an employee works only half of the month, their salary will be calculated as half of the full month's salary.">
                        <InfoCircleOutlined style={{ marginLeft: "5px" }} />
                      </Tooltip>
                    </span>
                  }
                  name="proRata"
                >
                  <Checkbox onChange={(e) => setProrata(e.target.checked)} />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "20px" }}
                  label="Taxable Component"
                  name="taxable"
                >
                  <Checkbox onChange={(e) => setTaxable(e.target.checked)} />
                </Form.Item>
                <Form.Item
                  style={{ marginBottom: "10px" }}
                  wrapperCol={{
                    offset: 8,
                    span: 12,
                  }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="large"
                    block
                    loading={loader}
                  >
                    Add Salary Component
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </Col>
        </Row>
      </UserPrivateComponent>
      <hr />
      <UserPrivateComponent permission={"readAll-setting"}>
        <CustomTable list={list} loading={loading} />
      </UserPrivateComponent>
    </Fragment>
  );
};

export default SalaryComponents;
